import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";

@Injectable()
export class BillingLetterProvider {
    public stepSubject: Subject<string> = new Subject();
    public savingEventSubject: Subject<boolean> = new Subject();
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/billing-letter-steps.provider.ts